import React, {useState, useEffect} from 'react';
export const ConfigContext = React.createContext();

const ConfigContextProvider = ({configUrl, ...props}) => {
    //const BASE_URL= window.location.hostname
    const [config, setConfig] = useState(null);
    const effectiveConfigUrl = configUrl || window.LIBRARY_CONFIG_URL;


    useEffect(() => {
      if(!config ) {
        fetch((effectiveConfigUrl || process.env.PUBLIC_URL)+"/config.json")
        .then(res => res.json())
        .then(
          (result) => {
            const data = (window.location.href.match(/flou/) && !window.location.href.match(/dev\./)) ? result.PROD : result.DEV;
            setConfig(data)
          },
          (error) => {
          }
        )
      }
    }, []);
    return (
        <ConfigContext.Provider value={config}>
            {(config) && props.children}
        </ConfigContext.Provider>
    );
};

export default ConfigContextProvider